import {
  Container,
  Row,
  Column,
  ActionBar,
  useApi,
  useAccessRightsQuery,
  Loader,
} from "lcm-iot-commons";

import { FormattedMessage, useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { Forbidden } from "lcm-iot-commons/client/lib/components/Errors/Forbidden";
import DocumentForm from "./DocumentForm";

export default function DocumentCreate() {
  const api = useApi();
  const intl = useIntl(); // to be passed to <Forbidden /> component
  const params = useParams<{ id: string; model: string }>();

  const { data: accessRights, isLoading: isLoadingAccessRights } =
    useAccessRightsQuery("Product", {
      enabled: !!params.id,
    });

  const { data: categoriesResponse, isLoading: isLoadingCategories } =
    api.getAll.useQuery("/document/categories", null, {
      enabled: !!params.id && !!(accessRights as $TSFixMe)?.canUpdate,
    });

  const documentCategories = (categoriesResponse as $TSFixMe)?.categories;

  return (
    !isLoadingAccessRights &&
    ((accessRights as $TSFixMe)?.canUpdate ? (
      <Container>
        <Row>
          <Column>
            <ActionBar>
              <h1>
                <FormattedMessage id="document_create.header" />
              </h1>
            </ActionBar>
          </Column>
        </Row>
        <Row>
          <Column lg="7">
            {!isLoadingCategories && (
              <DocumentForm
                createMode
                documentCategories={documentCategories}
              />
            )}
            <Loader loading={isLoadingCategories} />
          </Column>
        </Row>
      </Container>
    ) : (
      <Forbidden intl={intl} />
    ))
  );
}
